// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tag_wrapper__3gTer","clickable":"Tag_clickable__1ALjf","title":"Tag_title__2PFgK","selected":"Tag_selected__RmbuV","count":"Tag_count__SalhQ"};